"use client"

import { Flower } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `FlowerIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const FlowerIcon = component(Icon)({ as: Flower })
